package org.lennycodes.hldi.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.borderBottom
import com.varabyte.kobweb.compose.css.margin
import com.varabyte.kobweb.compose.css.textDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.styles.*

private val navItems = listOf(
    "Home" to "/",
    "About" to "/about",
    "Programs" to "/programs",
    "Projects" to "/projects",
    "Team" to "/team",
    "Blog" to "/blog",
    "Events" to "/events",
    "Gallery" to "/gallery",
    "Resources" to "/resources",
    "Contact" to "/contact"
)

private const val MOBILE_MENU_ID = "mobile-nav-menu"

@OptIn(DelicateApi::class)
@Composable
fun Navbar() {

    var isMenuOpen by remember { mutableStateOf(false) }

    Nav(
        attrs = Modifier
            .top(0.px)
            .left(0.px)
            .right(0.px)
            .padding(0.px, 24.px)
            .then(NavBarStyle.toModifier())
            .toAttrs()
    ) {
        A(
            href = "/",
            attrs = Modifier.then(LogoStyle.toModifier())
                .toAttrs()
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.px)
            ) {
                Img(
                    src = "logo.webp",
                    alt = "RN-HLDI",
                    attrs = Modifier.size(width = 100.px, height = 70.px)
                        .toAttrs()
                )





            }
        }
            Div(
                attrs = Modifier
                    .then(DesktopNavDiv.toModifier())
                    .toAttrs()
            ) {
                navItems.forEach { (name, path) ->
                    val isActive = window.location.pathname == path

                    A(
                        href = path,
                        attrs = Modifier

                            .padding(12.px, 20.px)
                            .fontWeight(600)
                            .then(NavItemStyle.toModifier())
                            .toAttrs {
                                if (isActive) {
                                    attr("aria-current", "page")
                                    style {
                                        color(HLDITheme.Colors.primary)
                                        backgroundColor(HLDITheme.Colors.accent)
                                    }
                                }
                            }
                    ) {
                        Text(name)
                    }
                }
                    }

        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(12.px)
                }
            }
        ) {
            A(
                href = "/get-involved",
                attrs = Modifier
                    .padding(10.px, 24.px)
                    .then(DonateBtnStyle.toModifier())
                    .toAttrs()
            ) {
                Text("Donate")
            }

            Button(
                attrs = Modifier
                    .then(MobileNavDiv.toModifier())
                    .styleModifier {
                        property("background", "none")
                        property("border", "none")
                        property("appearance", "none")
                    }
                    .toAttrs {
                        attr("aria-expanded", isMenuOpen.toString())
                        attr("aria-controls", MOBILE_MENU_ID)
                        attr("aria-label", if (isMenuOpen) "Close menu" else "Open menu")
                        onClick { isMenuOpen = !isMenuOpen }
                    }
            ) {
                Text(if (isMenuOpen) "✕" else "☰")
            }
        }
    }

    // Mobile Menu
    if (isMenuOpen) {
        Div(
            attrs = Modifier
                .top(80.px)
                .left(0.px)
                .right(0.px)
                .padding(24.px)
                .gap(16.px)
                .then(MobileMenuStyle.toModifier())
                .toAttrs {
                    id(MOBILE_MENU_ID)
                }
        ) {
            navItems.forEach { (name, path) ->
                val isActive = window.location.pathname == path

                A(
                    href = path,
                    attrs = {
                        style {
                            color(HLDITheme.Colors.text)
                            textDecorationLine(TextDecorationLine.None)
                            fontSize(18.px)
                            fontWeight(600)
                            padding(12.px, 0.px)
                            borderBottom(1.px, LineStyle.Solid, Color.rgba(0, 0, 0, 0.1f))

                            if (isActive) {
                                color(HLDITheme.Colors.primary)
                            }
                        }
                        if (isActive) {
                            attr("aria-current", "page")
                        }
                        onClick { isMenuOpen = false }
                    }
                ) {
                    Text(name)
                }
            }
        }
    }
}